import useAuthStore from '@/stores/useAuthStore/useAuthStore'
import { UserType } from '../useApi'

export const useCurrentUserType = (): UserType | null => {
    const userType = useAuthStore((state) => state.user?.type ?? null)

    return userType
}
